var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocumentRoundBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-161 -500) translate(8 488) translate(153 12) translate(.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.01,
    cy: 17.01,
    r: 17.01,
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.96 0H1.62C.729 0 0 .729 0 1.62v11.34c0 .891.729 1.62 1.62 1.62h11.34c.891 0 1.62-.729 1.62-1.62V1.62c0-.891-.729-1.62-1.62-1.62zM3.308 4.695v-1.62h5.67v1.62h-5.67zm0 3.24v-1.62h8.1v1.62h-8.1zm0 3.24v-1.62h3.24v1.62h-3.24z",
    transform: "translate(8.91 9.72) translate(.231) translate(.579)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentRoundBlue);
export default __webpack_public_path__ + "static/media/icon_document_round_blue.7f16ba1676e452951058879c55e535d8.svg";
export { ForwardRef as ReactComponent };